import { SVGProps } from ".";

export function RectangleIcon({ color = "black", size = 18 }: SVGProps) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        color={`${color}`}
        height={`${size}`}
        width={`${size}`}
        stroke={`${color}`}
        strokeWidth="0"
        fill="none"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.33333 4.5L18.6667 4.5C19.1269 4.5 19.5 4.8731 19.5 5.33333V18.6667C19.5 19.1269 19.1269 19.5 18.6667 19.5H5.33333C4.8731 19.5 4.5 19.1269 4.5 18.6667L4.5 5.33333C4.5 4.8731 4.8731 4.5 5.33333 4.5ZM6.16667 6.16667L6.16667 17.8333H17.8333V6.16667L6.16667 6.16667Z"
          fill={`${color}`}
        />
      </svg>
    </div>
  );
}
